<div *ngIf="!showRequest">

  <h2 *ngIf="isShow" class="sectionTitle">{{'FRONT_USER.MEASUREMNT_OFFICER_FORM.MEASUREMNT_OFFICER' | translate }}</h2>

  <div *ngIf="baseRequestId" class="read-only-content">
    <!--request Details summary-->
    <app-fees-estimation-request #feesEstimationRequest (historicalAdminSCNT)="receiveHistoricalAdminSCNT($event)"
      (historicalAdminSCGT)="receiveHistoricalAdminSCGT($event)" [IsAdminMode]="true"
      [AgentId]="agentId"></app-fees-estimation-request>
    <!-- <app-measurements-reviewer-decision  ></app-measurements-reviewer-decision> -->
  </div>

  <div *ngIf="baseRequestId">
    <form #measurementRequest [formGroup]="measurementOfficerForm">
      <!-- Reviewing Section -->

      <fieldset [disabled]="this.measurementOfficerForm.disabled">
        <div class="form-container">
          <div class="form-section">
            <h4 class="section-title">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MEASUREMENT_DECISION'| translate}}</h4>
            <div class="form-group">
              <label for="ReviewerDecision">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.DECISION' | translate}}</label>

              <span class="red">*</span>
              <div class="form-custom-inputs">
                <div *ngFor="let decisions of reviewerdecisionKeys;let i='index'" class=" custom-Radio">
                  <input type="radio" [id]=[decisions] (change)="changeDecision(reviewerdecision[decisions])"
                     name="ReviewerDecision"  [value]="reviewerdecision[decisions]"
                    formControlName="ReviewerDecision" />

                  <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>
                </div>
              </div>
              <div *ngIf="submitted && f.ReviewerDecision?.errors" class="red">
                <div *ngIf="f.ReviewerDecision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>

              </div>
            </div>

            <div *ngIf="reviewerdecisionValue == reviewerdecision.MoreInformation" class="form-group">
              <label for="MoreInformation">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' |
                translate}}</label>
              <span class="red">*</span>
              <textarea formControlName="MoreInformation" id="MoreInformation" name="MoreInformation"
                class="form-control"
                [ngClass]="{ 'is-invalid': submitted ||(f.MoreInformation?.dirty && f.MoreInformation?.errors) }"></textarea>
              <div *ngIf="submitted ||(f.MoreInformation?.dirty && f.MoreInformation?.errors)" class="red">
                <div *ngIf="f.MoreInformation?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>

            </div>
          </div>
        </div>

      </fieldset>
      <div class="form-container">

        <!-- Fees Section -->
        <div *ngIf="reviewerdecisionValue == reviewerdecision.Approve" class="form-section">
          <!-- Reviewing Group -->
          <!--           <h4 class="section-title">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MEASUREMENT_DECISION'| translate}}</h4>

          <div class="form-group">
            <label for="ReviewerDecision">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.DECISION' | translate}}</label>

            <span class="red">*</span>
            <div class="form-custom-inputs">
              <div *ngFor="let decisions of reviewerdecisionKeys;let i='index'" class=" custom-Radio">
                <input type="radio" [id]=[decisions] (change)="changeDecision(reviewerdecision[decisions])"  name="ReviewerDecision"
                   [value]="reviewerdecision[decisions]" formControlName="ReviewerDecision" />

                <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>
              </div>
            </div>
            <div *ngIf="submitted && f.Decision?.errors" class="red">
              <div *ngIf="f.Decision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

            </div>
          </div>

          <div *ngIf="reviewerdecisionValue == reviewerdecision.MoreInformation" class="form-group">
            <label
              for="MoreInformation">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' | translate}}</label>
            <span class="red">*</span>
            <textarea formControlName="MoreInformation" id="MoreInformation" name="MoreInformation"
              class="form-control"
              [ngClass]="{ 'is-invalid': submitted ||(f.MoreInformation?.dirty && f.MoreInformation?.errors) }"></textarea>
            <div *ngIf="submitted ||(f.MoreInformation?.dirty && f.MoreInformation?.errors)" class="red">
              <div *ngIf="f.MoreInformation?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>

          </div>  -->
          <!-- Fees Group -->
          <h4 class="section-title">{{'FRONT_USER.FEES_ESTIMATION_FORM.FEES'| translate}}</h4>

          <div class="form-group">
            <label for="Currency">{{'FRONT_USER.FEES_ESTIMATION_FORM.PAYMENT_CURRENCY' | translate}}</label>
            <input type="text" formControlName="Currency" class="form-control" />
          </div>

          <div class="form-group">
            <label for="FeeValue">{{ 'FRONT_USER.MEASUREMNT_OFFICER_FORM.FEES_VALUE' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="FeeValue" id="FeeValue" name="FeeValue" class="form-control" />
            <div *ngIf="submitted || (f.FeeValue?.dirty &&f.FeeValue?.errors)" class="red">
              <div *ngIf="f.FeeValue?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.FeeValue?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <!-- <div *ngIf="f.FeeValue?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div> -->
            </div>
          </div>

          <div class="form-group">
            <label for="InsuranceValue">{{ 'FRONT_USER.MEASUREMNT_OFFICER_FORM.INSURANCE_VALUE' | translate}}</label>
            <input type="text" formControlName="InsuranceValue" id="InsuranceValue" name="InsuranceValue"
              class="form-control" />
            <div *ngIf="submitted || (f.InsuranceValue?.dirty &&f.InsuranceValue?.errors)" class="red">
              <!-- <div *ngIf="f.InsuranceValue?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div *ngIf="f.InsuranceValue?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="MeasurementDescription">{{'FRONT_USER.MEASUREMNT_OFFICER_FORM.MEASUREMNT_REQUIREMENTS' |
              translate}}</label>

            <textarea formControlName="MeasurementDescription" id="MeasurementDescription" name="MeasurementDescription"
              class="form-control"></textarea>
          </div>

          <!-- Ship Situation Dropdown -->
          <div class="form-group">
            <label for="shipSituation">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_SITUATION' | translate }}</label>
            <span class="red">*</span>
            <select formControlName="shipSituation" id="shipSituation" class="form-control">
              <option value="" selected>{{ 'FRONT_USER.CHOOSE' | translate }}</option>
              <option *ngFor="let s of shipSituationsKeys" [value]="shipSituations[s]">{{s}}</option>
            </select>
            <div *ngIf="submitted || (f.shipSituation?.dirty && f.shipSituation?.errors)" class="red">
              <div *ngIf="f.shipSituation?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>

          <!-- Admin SCGT -->
          <div class="form-group">
            <label for="AdminSCGT">{{ 'FRONT_USER.MEASUREMNT_OFFICER_FORM.ADMIN_SCGT' | translate}}</label>
            <!-- <span class="red">*</span> -->
            <input type="text" formControlName="AdminSCGT" id="AdminSCGT" name="AdminSCGT" class="form-control" />
            <div *ngIf="submitted || (f.AdminSCGT?.dirty &&f.AdminSCGT?.errors)" class="red">
              <!-- <div *ngIf="f.AdminSCGT?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div *ngIf="f.AdminSCGT?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
            </div>
          </div>

          <!-- Admin SCNT -->
          <div class="form-group">
            <label for="AdminSCNT">{{ 'FRONT_USER.MEASUREMNT_OFFICER_FORM.ADMIN_SCNT' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="AdminSCNT" id="AdminSCNT" name="AdminSCNT" class="form-control"
              (input)="CaluclateAndPopulateTugBoats($event)" />
            <div *ngIf="submitted || (f.AdminSCNT?.dirty &&f.AdminSCNT?.errors)" class="red">
              <div *ngIf="f.AdminSCNT?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.AdminSCNT?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
            </div>
          </div>

          <!-- Escorting Tugs Section -->
          <div class="form-section" *ngIf="measurementOfficerForm.get('AdminSCNT')?.value != ''">
            <h4 class="section-title">{{'FRONT_USER.FEES_ESTIMATION_FORM.ESCORT_TUGS_SECTION'| translate}}</h4>
            <!-- <div class="table-responsive" formArrayName="escortTugs"> -->
            <div *ngIf="!measurementOfficerForm.disabled" class="tab-container">
              <div class="tab-pane">
                <p class="btns-holder">
                  <button type="button" class="btn SCAcustomBtn" Confirmation
                    (confirmationClick)="addEscortTugRule()">(+){{'FRONT_USER.ADD' | translate }}</button>
                </p>
              </div>
            </div>
            <table formArrayName="escortTugs" class="table table-bordered table-striped table-services">
              <thead>
                <tr>
                  <th><span>
                      {{'FRONT_USER.FEES_ESTIMATION_FORM.NUMBER_OF_TUGS' | translate}}
                    </span></th>
                  <th><span>
                      {{'FRONT_USER.FEES_ESTIMATION_FORM.REASON' | translate}}
                    </span></th>
                  <th><span>
                      {{'FRONT_USER.FEES_ESTIMATION_FORM.NOTE' | translate}}
                    </span></th>
                  <th *ngIf="!measurementOfficerForm.disabled"><span>Delete Escort Tug Rule</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tug of measurementOfficerForm.get('escortTugs')?.controls; let i = index"
                  [formGroupName]="i">
                  <td>
                    <input type="number" min="1" max="2" class="form-control" formControlName="tugsNumber" />
                    <div
                      *ngIf="submitted || ((tug.get('tugsNumber')?.dirty || tug.get('tugsNumber')?.touched) && tug.get('tugsNumber')?.errors)"
                      class="red">
                      <div *ngIf="tug.get('tugsNumber')?.errors?.required">
                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                      </div>
                      <div *ngIf="tug.get('tugsNumber')?.errors?.pattern">
                        {{'FRONT_USER.NUMBER_ERROR' | translate}}
                      </div>
                    </div>
                  </td>
                  <td><textarea class="form-control" formControlName="reason"></textarea></td>
                  <td><textarea class="form-control" formControlName="note"></textarea></td>
                  <td *ngIf="!measurementOfficerForm.disabled" style="text-align: center;"><a Confirmation
                      (confirmationClick)="deleteEscortTugRule(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <circle cx="16" cy="16" r="16" fill="#E53935" />
                        <path fill="#FFFFFF"
                          d="M21.656 10.344a1.2 1.2 0 0 0-1.697 0L16 14.303l-3.959-3.959a1.2 1.2 0 1 0-1.697 1.697L14.303 16l-3.959 3.959a1.2 1.2 0 1 0 1.697 1.697L16 17.697l3.959 3.959a1.2 1.2 0 0 0 1.697-1.697L17.697 16l3.959-3.959a1.2 1.2 0 0 0 0-1.697z" />
                      </svg>
                    </a></td>
                </tr>
              </tbody>
            </table>

            <!-- </div> -->
          </div>
        </div>
        <!--  <div *ngIf="formMode == FormMode.Add" class="form-section">
          <h4 class="section-title">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MEASUREMENT_DECISION'| translate}}</h4>

          <div class="form-group">
            <span class="red">*</span>
            <label for="Decision">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.DECISION' | translate}}</label>
            <div class="form-custom-inputs">

              <div *ngFor="let decisions of decisionKeys;let i='index'" class=" custom-Radio">
                <input type="radio" [id]=[decisions]  name="Decision"  [value]="decision[decisions]"
                  formControlName="Decision" />

                <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>

              </div>
            </div>
            <div *ngIf="submitted && f.Decision?.errors" class="red">
              <div *ngIf="f.Decision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

            </div>
          </div>
        </div> -->
        <div *ngIf="formMode == FormMode.Add" class="form-group">
          <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
            'FRONT_USER.SUBMIT' | translate}}</button>
        </div>
      </div>
    </form>

    <br>

  </div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>

  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>